import FeadToggle, {
  IFeadToggle,
} from "components/button/feadToggle/feadToggle";
import CalendarMb from "components/calendar/mb/calendar";
import { useBookInfContext } from "components/context/bookInfContext";
import { dateFormat, getDurationDate } from "util/commAction";
import i18n from "locales/i18n";
import { useRef } from "react";
import "./bookdates.scss";

interface IProps
  extends Omit<IFeadToggle, "children" | "btnStyle" | "handleClose"> {}

export default function BookingDatesMb({ text }: IProps) {
  const langCd = i18n.language;
  const { bookInf } = useBookInfContext();
  // const [isNext, setIsNext] = useState(false);

  const date = getDurationDate(bookInf?.dates[0], bookInf?.dates[1]);

  const start = new Date(dateFormat(bookInf?.dates[0]));
  const end = new Date(dateFormat(bookInf?.dates[1]));

  const startDay = start.toLocaleDateString(langCd, {
    // year: "numeric",
    month: "numeric",
    day: "numeric",
    weekday: "long",
  });

  const endDay = end.toLocaleDateString(langCd, {
    month: "numeric",
    day: "numeric",
    weekday: "long",
  });

  const desc =
    bookInf?.dates.length === 2 ? (
      <div className="text-center font-font-B mt-[-10px] pb-5">
        <h5>{date}</h5>
        <h5>
          {startDay}&nbsp;~&nbsp;{endDay}
        </h5>
      </div>
    ) : undefined;

  const calendarRef = useRef<HTMLDivElement>(null);

  const handleNext = () => {
    if (calendarRef.current) {
      const parent = calendarRef.current.parentElement as HTMLDivElement;
      parent.style.height = "0px";
      parent.classList.remove("visible");

      // 숙소 이용 정보를 visible
      const feadToggle = parent.closest("div.fead-toggle") as HTMLDivElement;
      const nextElment = feadToggle.nextElementSibling as HTMLDivElement;
      const rmInfElement = nextElment.lastChild as HTMLDivElement;
      rmInfElement.classList.add("visible");
      rmInfElement.style.height = "220px";
    }
  };

  return (
    <FeadToggle
      text={text}
      styles={"book-dates-mb"}
      btnStyles="btn-toggle"
      maxHeight={350}
      desc={desc}
    >
      <CalendarMb handleNext={handleNext} ref={calendarRef} />
    </FeadToggle>
  );
}
